// Note: This function doesn't remove any dom elements that intercom uses.
// It only removes the intercom object from the window object.
// Do not assume that if removeIntercom is called, that you can re-initialize intercom again.
// It's better to check if intercom has already booted with window?.Intercom?.booted
export function removeIntercom() {
  // Ensures that intercom is not initalized elsewhere, so we can cleanly boot it up.
  if (typeof window?.Intercom !== 'undefined' && window?.Intercom !== null) {
    // oxlint-disable-next-line new-cap
    window.Intercom('shutdown');
    delete window.intercomSettings;
    // @ts-expect-error: we know that Intercom is not null or undefined and we know it is on the window object
    delete window.Intercom;
  }
}
